module.exports = __webpack_public_path__ + "static/media/AetherLens.4fa2e42b.png";